import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Home2 } from './pages/Home2';
import { MarketIQ } from './pages/MarketIQ';
import { MarketIQHome } from './pages/MarketIQHome';
import { MarketIQPork } from './pages/MarketIQPork';
import { MarketIQChicken } from './pages/MarketIQChicken';
import { Article } from './pages/Article';
import { ExhibitA } from './pages/ExhibitA';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rikmp3jx47ah">
      <Routes data-id="element-1" data-mp="2mm2n0i3g2z50">
        <Route path="/" element={<Home2 data-id="element-3" data-mp="2mn5f2tci77mi" />} data-id="element-2" data-mp="2mmlut5zds75b" />
        <Route path="/home1" element={<Home data-id="element-5" data-mp="31agn4l9h89hv" />} data-id="element-4" data-mp="2mjpvbd7vxaer" />
        <Route path="/market-iq" element={<MarketIQHome data-id="element-7" data-mp="31c9uk2rwyxqx" />} data-id="element-6" data-mp="31ayr642drs0c" />
        <Route path="/market-iq/beef" element={<MarketIQ data-id="element-9" data-mp="2wjqgl4pbe0ll" />} data-id="element-8" data-mp="31cjou2jzrr2f" />
        <Route path="/market-iq/pork" element={<MarketIQPork data-id="element-11" data-mp="2wi5qbra193tj" />} data-id="element-10" data-mp="2wj8fnurpiy7c" />
        <Route path="/market-iq/chicken" element={<MarketIQChicken data-id="element-13" data-mp="28sur4e8bzhhi" />} data-id="element-12" data-mp="28tw3qn4zwc1c" />
        <Route path="/article" element={<Article data-id="element-15" data-mp="23w4g45bdvc2y" />} data-id="element-14" data-mp="23vcjcr61v8b3" />
        <Route path="/exhibit-a" element={<ExhibitA data-id="element-17" data-mp="23ti8k5ohswkq" />} data-id="element-16" data-mp="23ujl6el5pr4k" />
      </Routes>
    </BrowserRouter>;
}